import { put, takeEvery } from "redux-saga/effects";
import { createBrowserHistory } from "history";
import {
  FETCH_PRODUCTRETURNDETAILS_INIT_ACTION,
  FETCH_PRODUCTRETURNDETAILS_SUCCESS_ACTION,
  FETCH_PRODUCTRETURNDETAILS_FAIL_ACTION,
  FETCH_PRODUCTRETURNSEARCH_INIT_ACTION,
  FETCH_PRODUCTRETURNSEARCH_SUCCESS_ACTION,
  FETCH_PRODUCTRETURNSEARCH_FAIL_ACTION,
  FETCH_PRODUCTRETURNVIEW_INIT_ACTION,
  FETCH_PRODUCTRETURNVIEW_SUCCESS_ACTION,
  FETCH_PRODUCTRETURNVIEW_FAIL_ACTION,
  FILTER_BY_PRODUCTRETURN_STATUS_INIT_ACTION,
  FILTER_BY_PRODUCTRETURN_STATUS_SUCCESS_ACTION,
  FILTER_BY_PRODUCTRETURN_STATUS_FAIL_ACTION
} from "./action";
import { appConfig } from "../../config";
import "react-toastify/dist/ReactToastify.css";

function* fetchProductReturn(value) {
  const token = localStorage.getItem("token");
  let pageno = value.value === undefined ? 1 : value.value;
  try {
    const res = yield fetch(
      `${appConfig.ip}/purchaseOrder?orderType=return&&limit=10&page=` + pageno,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        }
      }
    );
    if (!res.ok) {
      let errJSON = {};
      try {
        errJSON = yield res.json();
      } catch {}
      throw Object.assign(res, errJSON);
    } else {
      const resJSON = yield res.json();

      yield put({
        type: FETCH_PRODUCTRETURNDETAILS_SUCCESS_ACTION,
        payload: resJSON
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({ type: FETCH_PRODUCTRETURNDETAILS_FAIL_ACTION, error: err });
    } else {
    }
  }
}

function* fetchSearchProductReturn(value) {
  let searchVal = value.value.ProductReturns;
  const token = localStorage.getItem("token");

  try {
    const res = yield fetch(
      `${appConfig.ip}/purchaseOrder?orderType=return&&limit=10&page=` +
        value.value.Spage +
        "&search=" +
        searchVal,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        }
      }
    );
    if (!res.ok) {
      let errJSON = {};
      try {
        errJSON = yield res.json();
      } catch {}
      throw Object.assign(res, errJSON);
    } else {
      const resJSON = yield res.json();

      yield put({
        type: FETCH_PRODUCTRETURNSEARCH_SUCCESS_ACTION,
        payload: resJSON
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({ type: FETCH_PRODUCTRETURNSEARCH_FAIL_ACTION, error: err });
    } else {
    }
  }
}

function* fetchProductReturnview(value) {
  // let id = value.value;
  const token = localStorage.getItem("token");
  try {
    const res = yield fetch(
      `${appConfig.ip}/orderDetails?orderId=` + value.value.item.id,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        }
      }
    );
    if (!res.ok) {
      let errJSON = {};
      try {
        errJSON = yield res.json();
      } catch {}
      throw Object.assign(res, errJSON);
    } else {
      const resJSON = yield res.json();

      yield put({
        type: FETCH_PRODUCTRETURNVIEW_SUCCESS_ACTION,
        payload: resJSON
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({ type: FETCH_PRODUCTRETURNVIEW_FAIL_ACTION, error: err });
    } else {
    }
  }
}

function* FliterSearchProductUser(value) {
  const token = localStorage.getItem("token");

  try {
    const res = yield fetch(
      `${appConfig.ip}/purchaseOrder?orderType=return&&limit=10&page=` +
        value.value.page +
        "&&status=" +
        value.value.value,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        }
      }
    );
    if (!res.ok) {
      let errJSON = {};
      try {
        errJSON = yield res.json();
      } catch {}
      throw Object.assign(res, errJSON);
    } else {
      const resJSON = yield res.json();
      console.log("FILTER_BY_PRODUCTRETURN_STATUS_SUCCESS_ACTION", resJSON);
      yield put({
        type: FILTER_BY_PRODUCTRETURN_STATUS_SUCCESS_ACTION,
        payload: resJSON
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: FILTER_BY_PRODUCTRETURN_STATUS_FAIL_ACTION,
        error: err
      });
    } else {
    }
  }
}

export function* ProductReturnActionWatcher() {
  yield takeEvery(FETCH_PRODUCTRETURNDETAILS_INIT_ACTION, fetchProductReturn);
  yield takeEvery(
    FETCH_PRODUCTRETURNSEARCH_INIT_ACTION,
    fetchSearchProductReturn
  );
  yield takeEvery(FETCH_PRODUCTRETURNVIEW_INIT_ACTION, fetchProductReturnview);

  yield takeEvery(
    FILTER_BY_PRODUCTRETURN_STATUS_INIT_ACTION,
    FliterSearchProductUser
  );
}
